module.exports = __webpack_public_path__ + "/img/5b1abe047bc7d0adae08582d8b227f67.png";